const HisMaximize = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7306 4.14844H6.73063C6.02339 4.14844 5.34511 4.42939 4.84501 4.92949C4.34492 5.42958 4.06396 6.10786 4.06396 6.8151V10.8151"
        stroke={strokeColor}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.0641 10.8151V6.8151C28.0641 6.10786 27.7832 5.42958 27.2831 4.92949C26.783 4.42939 26.1047 4.14844 25.3975 4.14844H21.3975"
        stroke={strokeColor}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.06396 21.4844V25.4844C4.06396 26.1916 4.34492 26.8699 4.84501 27.37C5.34511 27.8701 6.02339 28.151 6.73063 28.151H10.7306"
        stroke={strokeColor}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3975 28.151H25.3975C26.1047 28.151 26.783 27.8701 27.2831 27.37C27.7832 26.8699 28.0641 26.1916 28.0641 25.4844V21.4844"
        stroke={strokeColor}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisMaximize;
